import {  useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Space, Select, DatePicker, Modal, Form, message} from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import {  SelectStores } from "../../component/common/Selects"
import getPermission from '../../js/permission'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker


const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 12 }
}

interface ep {
    "employee_id": string,
    "user_name": string
}
type fetchParams = {
    store_id: undefined | string,
    belong_nurse_id: undefined| string,
    room_type_id: undefined | string,
    check_in_phone: undefined | string,
    check_in_user_name: undefined | string,
    handle_status: number|undefined,
    complaint_department_id: string | undefined,
    room_number: string | undefined,
    inDate: any
    handleDate:any
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: false
}

type department = {
    "room_type_id": string,
    "room_type_name": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        check_in_user_name: undefined,
        check_in_phone: undefined,
        room_type_id:undefined,
        belong_nurse_id:undefined,
        store_id: undefined ,
        handle_status: undefined,
        complaint_department_id:  undefined,
        room_number: undefined,
        inDate: null,
        handleDate:null
    }


    const [activeRecord, setActiveRecord] = useState<{ id: string, no_yet_pay_amount?: number, user_name?: string } | undefined>()
    const [form] = Form.useForm()

    const [recordInVisible, setRecordInVisible] = useState<boolean>(false)
    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })
    const [data, setData] = useState<any>([])
    const [bmData,setBmData] = useState<department[]>([])
    const [handleNameData,setHandleNameData] = useState<any[]>([])
    const [recordInBmData,setRecordInBmData] = useState<department[]>([])
    const [loading,setLoading] = useState<boolean>(false)

    const permission: string[] = useMemo(() => {
        console.log(getPermission())
        return getPermission()
    }, [window.location.pathname])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value
        setFetchOtherParams(params)
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)
        let p: any = { ...pagination }
        p.current = 1
        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        setPagination(p)
    }
    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')
            delete param[attr]
        }
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current
        
        let params: any = { ...fetchOtherParams }
        
        handleDate(params, 'inDate', ['nursing_start_day', 'nursing_end_day'])

        axiosTable.get('/nursing/item_nursing_report/page_list', {
            params: {
                ...iPagination,
                ...params
            }
        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }
            setLoading(false)
        })
    }

    const handleSearch = () => {
        
        const p = { ...pagination }
        p.current = 1
        fetch({ pagination: p, fetchOtherParams })
    }


    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current])

    type project = {
        id: string
        item_name: string
    }
    const [selectNameData,setSelectNameData] = useState<project[]>([])
    let bmOptions = bmData.map((el:any)=>(<Option value={el.room_type_id} key={el.room_type_id}>{el.room_type_name}</Option>)) 
    let ItemNameOptions = selectNameData.map((el:any)=>(<Option value={el.id} key={el.id}>{el.item_name}</Option>)) 
    const [gjData,setGjData] = useState<ep[]>([])
    
    const exportExcel = ()=>{
        const iPagination: any = { ...pagination }
        iPagination.size = iPagination.pageSize
        iPagination.page = iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.current
        delete iPagination.showSizeChanger
        
        let params: any = { ...fetchOtherParams }
        if (params.inDate) {
            params.nursing_start_day	 = params.inDate[0].format('YYYY-MM-DD')
            params.nursing_end_day = params.inDate[1].format('YYYY-MM-DD')
            delete params.inDate
        }

        baseAxiosComplete('/nursing/item_nursing_report/export',{params:{
            ...iPagination,
            ...params
        }}).then(res=>{
            if(res.status===0){
                window.open(res.data)
            }
        })
    }

    return (<div className="common-page">
        <BreadCrumb position={['护理中心', '项目护理报表']} />
        <div className="common-top-form">
            <div className="clear">
                <div className="fl" style={{ marginRight:12,marginBottom:12 }}><SelectStores value={fetchOtherParams.store_id} onChange={(v: string) => { 
                    handleChange(v, 'store_id') 
                    // 查询护士列表
                    baseAxiosNoInfo('/global/employee_list_by_position',{params:{
                        department_id:v,
                        position_number:'35'
                    }}).then((res:any)=>{
                        res && setGjData(res)
                    })
                }} /></div>
                <Input className="fl"  style={{ width: '120px',marginRight:12,marginBottom:12 }} placeholder="入住房号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'room_number') }} value={fetchOtherParams.room_number} />
                <Select  className="fl"  virtual={false} style={{ width:'190px',marginRight:12,marginBottom:12 }} placeholder="护士（先选门店）"  onChange={(e: string) => { handleChange(e, 'belong_nurse_id') }} value={fetchOtherParams.belong_nurse_id}>
                        {gjData.map((el:ep)=><Option value={el.employee_id} key={el.user_name}>{el.user_name}</Option>)}
                </Select>
                <Input className="fl"  style={{ width: '120px',marginRight:12,marginBottom:12 }} placeholder="入住手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_phone') }} value={fetchOtherParams.check_in_phone} />
                <Input className="fl"  style={{ width: '120px',marginRight:12,marginBottom:12 }} placeholder="入住人姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'check_in_user_name') }} value={fetchOtherParams.check_in_user_name} />
                
                {/* <Select className="fl" virtual={false}  style={{ width: 120,marginRight:12,marginBottom:12 }} placeholder="套餐" value={fetchOtherParams.belong_nurse_id} onChange={(v: string) => { handleChange(v, 'belong_nurse_id') }}>
                    {ItemNameOptions}
                </Select>
                <Select className="fl"  virtual={false}  style={{ width: 260,marginRight:12,marginBottom:12 }} placeholder="房型" value={fetchOtherParams.room_type_id} onChange={(v: any) => { handleChange(v, 'room_type_id') }}>
                    {bmOptions}
                </Select> */}
                <RangePicker style={{marginRight:12,marginBottom:12 }} className="fl"  placeholder={["护理开始日期", "护理结束日期"]} value={fetchOtherParams.inDate} onChange={(v: any) => { handleChange(v, 'inDate') }} />
                {permission.includes('查询') && <Button style={{marginRight:12,marginBottom:12 }}   className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>}
                <Button className="fl" style={{marginRight:12,marginBottom:12 }}  onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('导出') && <Button className="fl"  onClick={()=>{exportExcel()}} type="dashed" >导出</Button>}
            </div>
        </div>
        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{x:'max-content'}} bordered={true}  pagination={pagination} onChange={handleTableChange}>
                <Column title="门店"  dataIndex="store_name" key="store_name" />
                <Column title="入住人"  dataIndex="check_in_user_name" key="check_in_user_name" />
                <Column title="手机号"  dataIndex="check_in_phone" key="check_in_phone" />
                <Column  title="房间号" dataIndex="room_number" key="room_number" />
                <Column  title="项目护理" dataIndex="nursing_care_item_desc" key="nursing_care_item_desc" />
                <Column  title="护士" dataIndex="nurse_name" key="nurse_name" />
                <Column  title="宝宝体重" dataIndex="baby_weight" key="baby_weight" />
                <Column  title="护理记录" dataIndex="nursing_records" key="nursing_records" />
                <Column   title="护理时间" dataIndex="nursing_time" key="nursing_time" />
            </Table>
        </div>

    </div>)
}